export const getters = {
  today: (state: any) =>  state.today,
  last7days: (state: any) => state.last7days,
  hourly: (state: any) => state.hourly
}
